import * as Yup from "yup";

export const registrationNameAndDescriptionSchema = Yup.object().shape({
  displayName: Yup.string().required(),
  description: Yup.string().max(200).required(),
});
